var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "background",
      style: { backgroundImage: `url(${_vm.backgroundImage})` },
    },
    [
      _c("content-container", [
        _c("div", { staticClass: "content" }, [
          _c("h1", { staticClass: "title" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(`${_vm.locationLabelShow}'s Best Restaurants`) +
                "\n\t\t\t"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.subTitle)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-row" }, [
            _c(
              "div",
              { staticClass: "input-col" },
              [
                _c("input-address", {
                  ref: "address",
                  attrs: {
                    savedAddresses: _vm.savedAddresses,
                    isLoggedIn: _vm.restListHeader.inputAddress.isLoggedIn,
                    defaultAddress: _vm.defaultAddress,
                  },
                  on: {
                    "address-set": _vm.getNewRestList,
                    noResults: _vm.showGoogleMap,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-col" },
              [
                _c("input-restaurant-search", {
                  attrs: {
                    placeholder:
                      "Search All " + _vm.locationLabel + " Restaurants",
                  },
                  on: { input: _vm.handleInputChange },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.showMapModal
        ? _c(
            "modal",
            {
              on: {
                hideModal: function ($event) {
                  return _vm.hideMapModal()
                },
              },
            },
            [
              _c("google-map", {
                attrs: {
                  mapDefaultZoom: _vm.mapDefaultZoom,
                  mapCenterLat: _vm.mapCenterLat,
                  mapCenterLng: _vm.mapCenterLng,
                },
                on: { addressSelected: _vm.handleMapAddressSelected },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }